import styled from "styled-components";

export interface CoverProps {
  title?: string;
  keyword?: string;
  email?: string;
  companyName?: string;
  location?: string;
}
const Wrap = styled.div`
  width: 60vw;
  height: 100vh;
  background-color: #d65226;
  margin: 0 auto;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 32px;
  justify-content: center;
  align-items: center;
  @media screen and (width < 800px) {
    width: 100vw;
    margin: 0;
  }
  @media print {
    width: auto;
    height: 100vh;
  }
`;
const Title = styled.div`
  font-weight: 800;
  font-size: 40px;
  line-height: 48px;
`;
const Keyword = styled.div`
  font-weight: 500;
  font-size: 32px;
  line-height: 38px;
`;
const Email = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
`;
const Detail = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
`;
const DetailWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
export const Cover = ({
  title,
  keyword,
  email,
  companyName,
  location,
}: CoverProps) => {
  return (
    <Wrap>
      <Title>{title}</Title>
      <Keyword>{keyword}</Keyword>
      <Email>{email}</Email>
      <DetailWrap>
        <Detail>{companyName}</Detail>
        <Detail>{location}</Detail>
      </DetailWrap>
    </Wrap>
  );
};
